import { combineReducers } from "redux";

import auth from "./authReducer";
import usersInfoData from "./usersReducer";
import userInfoData from "./userReducer";
import loginReducer from './loginReducer'
import registrationInfo from './registrationReducer'
import ordersReducer from './ordersReducer'
import productsData from './productsReducer'
import sportsReducer from './sportsReducer'
import betsReducer from './betsReducer'

import statisticReducer from './statisticReducer'

import freeBetPageData from './freeBetPageReducer'

import navigationData from './navigationReducer'

import betVideosData from './betVideosReducer'

import webpageReducer from './webpageReducer'

import fcmSubscriptionReducer from './fcmSubscriptionReducer'

import usersUnitsData from './usersUnitsReducer'

import subscribersData from './subscribersReducer'

export default combineReducers({
  auth,

  usersInfoData,
  userInfoData,
  subscribersData,

  productsData,

  freeBetPageData,

  usersUnitsData,

  fcmSubscriptionData: fcmSubscriptionReducer.fcmSubscriptionData,
  fcmDeviceSubscriptionToken : fcmSubscriptionReducer.fcmDeviceSubscriptionToken,
  fcmDeviceSubscriptionSupport : fcmSubscriptionReducer.fcmDeviceSubscriptionSupport,

  sportsData: sportsReducer.sportsData,
  sportEventsData: sportsReducer.sportEventsData,
  sportParticipantsData: sportsReducer.sportParticipantsData,

  premiumBetHistoryData: betsReducer.betHistory,
  premiumBetsData: betsReducer.premiumBets,

  packageStatisticData: statisticReducer.packageStatisticData,
  statisticData: statisticReducer.statisticData,

  loginDialog: loginReducer.loginDialog,
  loginDialogInfo: loginReducer.loginDialogInfo,

  registrationInfo,

  orderDialog: ordersReducer.orderDialog,
  ordersData: ordersReducer.ordersData,
  ordersHistoryData : ordersReducer.ordersHistoryData,
  commitedOrderData: ordersReducer.commitedOrderData,

  navigationData,

  betVideosData,

  userAgreementDialog: webpageReducer.userAgreementDialog,
  webpageInfoData: webpageReducer.webpageInfoData,
  transactionInProccess : webpageReducer.transactionInProccess,
  monetaTransactionInProccess: webpageReducer.monetaTransactionInProccess,
  cookiesInfoDialog: webpageReducer.cookiesInfoDialog,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js